import LabelLang, { LabelLangString } from "component/LabelLang/label-lang.js";

function MicrofilmSelectField({
  label,
  dir,
  currentLocale,
  registerProps,
  options,
  translationKey,
}) {
  return (
    <div className="form-label row">
      <div className="col-lg-4">
        <label>{label}</label>
      </div>
      <div className="col-lg-8">
        <div className="dropdown">
          <select
            className={`${dir === "rtl" ? "r-dir" : "l-dir"}`}
            {...registerProps}
          >
            {options.map(({ id, name, ...rest }, i) => {
              const translations = rest[translationKey];
              return (
                <option
                  key={i}
                  value={id}
                  title={LabelLangString({
                    id: "name",
                    currentLocale,
                    defaultValue: name,
                    translations,
                  })}
                >
                  <LabelLang
                    id="name"
                    defaultValue={name}
                    translations={translations}
                  />
                </option>
              );
            })}
          </select>
          <span>*</span>
        </div>
      </div>
    </div>
  );
}

export default MicrofilmSelectField;
